import { Injectable } from '@angular/core';
import { ApiFeatureSelector, Filter, Pagination } from '@iot-platform/models/common';
import { Device } from '@iot-platform/models/i4b';
import * as fromDevices from '../reducers/devices.reducer';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { DataGuardCheckStatus } from '@iot-platform/models/data-guard';

@Injectable({
  providedIn: 'root'
})
export class DevicesSelectors extends ApiFeatureSelector<fromDevices.State, Device, Pagination, Filter> {
  selectDeviceTags = fromDevices.devicesFeature.selectTags;
  selectDeviceTagsLoading = fromDevices.devicesFeature.selectTagsLoading;
  selectDeviceTagsLoaded = fromDevices.devicesFeature.selectTagsLoaded;
  selectDataGuardStatus: MemoizedSelector<fromDevices.State, DataGuardCheckStatus | null> = createSelector(
    this.selectState,
    (state: fromDevices.State) => state.dataGuardStatus
  );
  constructor() {
    super(fromDevices.devicesFeature.selectDevicesState, fromDevices.adapter);
  }
}
